import React, { useState, useEffect } from 'react';
import StockCheckTable from './StockCheckTable';

import { Button, Card, Row, Col } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import { toast } from 'react-toastify';
import BasicTemplate from 'components/Toast/BasicTemplate';
import { swalConfirm } from 'components/utilities/SwalToastUtil';
import { stockBulkCheck } from 'services/stock-location/stockMovementService';
import InputScanBinPanel from '../InputScanBinPanel';
import PropTypes from 'prop-types';

const baseColumns = [
  {
    Header: 'Emplas Code',
    accessor: 'emplasCode',
    required: true
  },
  {
    Header: 'Supplier Code',
    accessor: 'supplierCode',
    required: true
  },
  {
    Header: 'Description',
    accessor: 'description',
    disabled: true
  },
  {
    Header: 'Pack Qty',
    accessor: 'packQty',
    disabled: true,
    required: true,
    type: 'number'
  },
  {
    Header: 'M/units stock',
    accessor: 'mUnitStock',
    disabled: true,
    required: true,
    type: 'number'
  },
  {
    accessor: 'count',
    Header: 'Count',
    required: true,
    type: 'number'
  }
];
export default function StockCheck({ binObjIn, isShowHeader = true }) {
  const [binObj, setBinObj] = useState(binObjIn);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setBinObj(binObj);
  }, [binObjIn]);
  const handleSubmit = async () => {
    swalConfirm('Are you sure?', 'This action cannot be undone.', async () => {
      handleBulkStockCheck([
        ...tableData.map(x => {
          return { ...x, binBarcode: binObj.binBarcode };
        })
      ]);
    });
  };

  const handleBulkStockCheck = async request => {
    const checkRq = [
      ...request.map(x => {
        return {
          ...x,
          qty: x.count,
          productId: x.productId
        };
      })
    ];

    console.log(checkRq);

    let checkRs = await stockBulkCheck(checkRq);
    if (checkRs.success) {
      toast.success(<BasicTemplate success={true} text={'All Successed!'} />);
    } else {
      Object.entries(checkRs.data).forEach(([key, value]) => {
        const errItem = checkRq.find(
          x => `${x.productId}-${x.binBarcode}` == key
        );
        if (errItem) {
          toast.error(
            <BasicTemplate
              success={false}
              text={`${errItem.productCode} check to ${errItem.binBarcode} failed: ${value}`}
            />,
            { autoClose: false }
          );
        }
      });
      checkRq.forEach(item => {
        console.log(item);
        if (!checkRs.data[`${item.productId}-${item.binBarcode}`]) {
          toast.success(
            <BasicTemplate
              success={true}
              text={`${item.productCode} check to ${item.binBarcode}  successfully!`}
            />
          );
        }
      });
    }
    return checkRs;
  };

  return (
    <>
      {isShowHeader && (
        <PageHeader
          title="Stock Check"
          description={`Manage and view all available stock from this page.`}
          className="mb-3"
        ></PageHeader>
      )}

      <InputScanBinPanel
        binObjIn={binObj}
        outputData={bin => {
          setBinObj(bin);
        }}
      />
      {binObj?.location && (
        <Card>
          <Card.Body className="overflow-hidden p-lg-4">
            <Row className="align-items-center justify-content-between">
              <StockCheckTable
                useAddedRow={true}
                data={[]}
                columns={baseColumns}
                loading={false}
                onRowAdded={setTableData}
              />
            </Row>
            <Row className="justify-content-center mt-3">
              <Col md={3} className="text-center">
                <Button
                  variant="success"
                  style={{ width: '220px' }}
                  size="sm"
                  onClick={handleSubmit}
                >
                  UPDATE CHANGES
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}
    </>
  );
}

StockCheck.propTypes = {
  isShowHeader: PropTypes.bool,
  binObjIn: PropTypes.object,
};